var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWidgetsMainLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 208.1 50",
    style: {
      enableBackground: "new 0 0 208.1 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1823A0;}\n\t.st1{fill:#F7146C;}\n\t.st2{fill:#333333;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0l29,50l6.3-10.9l-20-34.6C13.6,1.7,10.5,0,7.3,0H0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.8,34.1L40,15.2c-1.6-2.8-4.7-4.6-7.9-4.6h-7.3l13.5,23.5H50.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.8,34.1H38.2l17-29.5C56.8,1.8,59.8,0,63.1,0h7.3L50.8,34.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120.2,10.2v6.1l-5.2,0c-5,0-9.3,4.1-9.2,9.2c0.1,4.9,4.1,8.9,9,8.9h0.5c4.7,0,8.6-3.8,8.6-8.6v-8.7v-0.8 v-2.5C123.8,11.8,122.2,10.2,120.2,10.2L120.2,10.2z M120.2,25.8c0,2.7-2.2,4.9-4.9,4.9h-0.5c-3,0-5.4-2.4-5.4-5.4 s2.4-5.4,5.4-5.4h5.4V25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.4,26.7l-3.8-6.4l-3.8,6.4l-5.3-8.8c-0.7-1.1-1.8-1.8-3.1-1.8h-2.1l10.5,18.2l3.8-6.8l3.8,6.8l10.5-18.2 h-2.1c-1.3,0-2.4,0.7-3.1,1.8L87.4,26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144,18.2v-1.8h-9c-5,0-9,4-9,9s4,9,9,9h0.5c1.8,0,3.5-0.6,4.9-1.6c-0.2,2.9-2.6,5.2-5.4,5.2l-0.1,0 c-2.1,0-4.1-0.5-5.9-1.5l-1.7,3.2c2.3,1.2,4.9,1.9,7.6,1.9l0.1,0h0c5,0,9.1-4.2,9.1-9.2L144,18.2L144,18.2z M135.5,30.8H135 c-3,0-5.4-2.4-5.4-5.4S132,20,135,20h5.4v5.9C140.4,28.6,138.2,30.8,135.5,30.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.8,13.7c1,0,1.8-0.8,1.8-1.8s-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8S100.8,13.7,101.8,13.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 16,
    className: "st2",
    width: 3.6,
    height: 18.4
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.3,16.4H171l0-6.2l0,0c-2,0-3.6,1.6-3.6,3.6l0,2.6H165V20h2.4l0,5.1c0,5.1,4.1,9.2,9.1,9.2l0.9,0v-3.6 l-0.8,0c-3,0-5.5-2.5-5.5-5.6l0-5.1h6.3V16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M154.8,34.4c-4.9-0.2-8.6-4.4-8.6-9.2v-8.8h9c5,0,9,4,9,9v1.8h-11v0c0-2,1.6-3.6,3.6-3.6h3.4 c-0.7-2.1-2.8-3.6-5.1-3.6h-5.4v5.3c0,2.8,2.1,5.3,5,5.5c1.5,0.1,3-0.4,4.1-1.4l2.5,2.6C159.6,33.6,157.3,34.5,154.8,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M190.3,23.6L190.3,23.6l-0.2,0h-5.1c-1.1,0-2-0.8-2-1.7v-0.2c0-0.9,0.9-1.7,2-1.7h5.3c0.9,0,1.7,0.5,1.9,1.2 l3.4-1.2c-0.8-2.2-2.9-3.6-5.3-3.6h-5.3c-3.1,0-5.6,2.4-5.6,5.3v0.2c0,2.9,2.4,5.2,5.4,5.3v0h0.2h5.1c1.1,0,2,0.8,2,1.7v0.2 c0,0.9-0.9,1.7-2,1.7h-5.3c-0.9,0-1.7-0.5-1.9-1.2l-3.4,1.2c0.8,2.2,2.9,3.6,5.3,3.6h5.3c3.1,0,5.6-2.4,5.6-5.3v-0.2 C195.7,26,193.3,23.7,190.3,23.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.2,20.8l-0.1-1h0c-0.4,0.6-1.2,1.1-2.3,1.1c-1.6,0-2.3-1.1-2.3-2.2c0-1.9,1.6-2.9,4.6-2.8v-0.2 c0-0.6-0.2-1.8-1.7-1.8c-0.7,0-1.5,0.2-2,0.6l-0.3-0.9c0.6-0.4,1.6-0.7,2.5-0.7c2.3,0,2.9,1.6,2.9,3.1V19c0,0.7,0,1.3,0.1,1.8 H203.2z M203,16.9c-1.5,0-3.2,0.2-3.2,1.7c0,0.9,0.6,1.3,1.3,1.3c1,0,1.6-0.6,1.9-1.3c0-0.1,0.1-0.3,0.1-0.4V16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208.1,11c0,0.5-0.3,0.9-0.9,0.9c-0.5,0-0.8-0.4-0.8-0.9c0-0.5,0.4-0.9,0.9-0.9 C207.8,10.2,208.1,10.5,208.1,11z M206.6,20.8v-7.7h1.4v7.7H206.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetsMainLogo);
export default __webpack_public_path__ + "static/media/widgets_main_logo.7d4d650e8183bc76c720d4fd41f1cecc.svg";
export { ForwardRef as ReactComponent };